export const getAvatarSrc = (id: number) => (
  `${process.env.CALENDAR_APP_URL}:3443/api/user/photo/${id}`
);
